var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.87,
    height: 34.87,
    viewBox: "0 0 34.87 34.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9587",
    "data-name": "Group 9587",
    transform: "translate(-1549.326 -3147.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3595",
    "data-name": "Path 3595",
    d: "M1547.721,5405.663a17.435,17.435,0,1,0-20.159,17.223V5410.7h-4.427v-5.04h4.427v-3.841c0-4.37,2.6-6.783,6.585-6.783a26.86,26.86,0,0,1,3.9.34v4.291h-2.2a2.52,2.52,0,0,0-2.841,2.723v3.27h4.835l-.773,5.04h-4.062v12.183A17.44,17.44,0,0,0,1547.721,5405.663Z",
    transform: "translate(36.475 -2241.157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3596",
    "data-name": "Path 3596",
    d: "M1537.073,5410.7l.773-5.04h-4.835v-3.27a2.52,2.52,0,0,1,2.841-2.723h2.2v-4.291a26.86,26.86,0,0,0-3.9-.34c-3.982,0-6.585,2.413-6.585,6.783v3.841h-4.427v5.04h4.427v12.183a17.62,17.62,0,0,0,5.449,0V5410.7Z",
    transform: "translate(36.475 -2241.157)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbBlack);
export default __webpack_public_path__ + "static/media/fb-black.a80c1ff5181bd3cc3a89824ffcc6f29d.svg";
export { ForwardRef as ReactComponent };